import React from 'react';
import { Badge } from '../ui/Badge';
import { formatDate } from '../../utils/format';

interface Props {
  validUntil?: string | null;
}

export function ValidityBadge({ validUntil }: Props) {
  if (!validUntil) return null;

  const now = new Date();
  const expiry = new Date(validUntil);
  const diffDays = Math.ceil((expiry.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));

  if (diffDays < 0) {
    return <Badge variant="error">Scaduto il {formatDate(validUntil)}</Badge>;
  }
  if (diffDays <= 30) {
    return <Badge variant="warning">Scade tra {diffDays} giorni</Badge>;
  }
  return null;
}
